module.exports = __webpack_public_path__ + "static/assets/0017acb29de67f39330662586d07bcae.jpg";